<template>
  <div id="add-topik">
    <form action="#" v-on:submit.prevent="submitForm">
      <div
        class="form-group"
        id="add-topik-modal-select"
        v-if="tipe_project == 1 && is_formed"
      >
        <label for="inputTopik">Grup Topik</label>
        <select
          name="topik"
          id="selectTopik"
          v-model="selected_grup"
          class="form-control"
          style="cursor: pointer"
          required
        >
          <option value="">Pilih Grup Topik</option>
          <option v-for="(row, index) in group" :key="index" :value="index">
            {{ row }}
          </option>
        </select>
      </div>
      <div class="form-group">
        <label for="inputTopik">Topik</label>
        <input
          type="text"
          name="topik"
          v-model="topik"
          class="form-control"
          autofocus
          placeholder="Masukkan Topik"
          required
        />
      </div>
      <div class="form-group" align="right">
        <button type="button" class="btn btn-danger m-r-5" data-dismiss="modal">
          Batal
        </button>
        <button type="submit" class="btn btn-primary">Simpan</button>
      </div>
    </form>
    <floating-loader-component v-if="is_loading" />
  </div>
</template>

<script>
import $ from "jquery";
import notif from "@/assets/js/notif.js";
import floating_loader from "@/views/components/floating_loader.vue";

$.pgNotification = notif;
export default {
  name: "modal_add_topic",
  props: {
    data: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  components: {
    "floating-loader-component": floating_loader,
  },
  data() {
    return {
      topik: null,
      id_project:
        this.$store.getters.user.id_project != 0
          ? this.$store.getters.user.id_project
          : parseInt(atob(this.$route.query.ref)),
      tipe_project:
        this.$store.getters.user.id_project != 0
          ? this.$store.getters.user.project.project_detail.tipe
          : this.data[0].tipe_project,
      error: 0,
      selected_grup:
        this.data.length > 0
          ? this.data[0].selected_group
            ? this.data[0].selected_group
            : ""
          : "",
      is_formed:
        this.data.length > 0
          ? "tipe" in this.data[0]
            ? this.data[0].tipe == 2
              ? true
              : false
            : false
          : false,
      group: this.data.length > 0 ? this.data[0].group : {},
      callback:
        this.data.length > 0
          ? "callback" in this.data[0]
            ? this.data[0].callback
            : null
          : null,
      is_loading: false,
    };
  },
  methods: {
    submitForm: function () {
      if (this.tipe_project == 1) {
        if (this.is_formed) {
          this.saveData(this.topik, 2, this.selected_grup);
        } else {
          this.saveData(this.topik, 1, null);
        }
      } else {
        this.saveData(this.topik, 1, null);
      }
    },
    saveData: function (topik, tipe, group) {
      this.$store.dispatch("loading", true);

      let params = {
        topic: this.$sanitize(topik),
        group_id: group,
        id_project: this.id_project,
        tipe: tipe,
      };
      let api;
      api = process.env.VUE_APP_API_URL + "new-topic-add";
      this.is_loading = true;
      this.$http
        .post(api, params)
        .then((response) => {
          if (response.status == 200) {
            if (this.callback) {
              this.callback();
            }
            this.$store.dispatch("loading", false);
            this.topik = null;
            if (response.data.status == "Topic already exist") {
              $("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-x-circle"></i> <b>Error!</b> Topik telah tersedia!',
                  position: "top",
                  timeout: 5000,
                  type: "danger",
                })
                .show();
            } else {
              $("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Topik berhasil ditambahkan!',
                  position: "top",
                  timeout: 5000,
                  type: "success",
                })
                .show();
            }
          } else {
            this.$store.dispatch("loading", false);
            $("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan pada saat menambahkan Topik!',
                position: "top",
                timeout: 5000,
                type: "danger",
              })
              .show();
          }
        })
        .catch(() => {
          this.$store.dispatch("loading", false);
          $("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan pada saat menambahkan Topik!',
              position: "top",
              timeout: 5000,
              type: "danger",
            })
            .show();
        })
        .finally(() => {
          this.is_loading = false;
          this.$("#modalSlideUp").modal("hide");
        });
    },
    showNotif: function () {
      if (this.error == 0) {
        this.$parent.$parent.getTopic();
        $("#modalSlideUp").modal("hide");
        $("body")
          .pgNotification({
            style: "bar",
            message:
              '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Topik berhasil ditambahkan!',
            position: "top",
            timeout: 5000,
            type: "success",
          })
          .show();
      } else if (this.error > 0 && this.error < this.tipe.length) {
        this.$parent.$parent.getTopic();
        $("#modalSlideUp").modal("hide");
        $("body")
          .pgNotification({
            style: "bar",
            message:
              '<i class="bi bi-check-circle"></i> <b>Perhatian!</b> Topik berhasil ditambahkan hanya pada satu jenis media!',
            position: "top",
            timeout: 5000,
            type: "warning",
          })
          .show();
      } else {
        $("#modalSlideUp").modal("hide");
        $("body")
          .pgNotification({
            style: "bar",
            message:
              '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan pada saat menambahkan Topik!',
            position: "top",
            timeout: 5000,
            type: "danger",
          })
          .show();
      }
    },
  },
};
</script>